export const offer = {
  name: 'CATEQUESIS LISTAS',
  price: '$19.990',
  oldPrice: '$39.990',
  discount: '50% OFF',
  currency: 'ARS',
  totalPages: 205,
  packPages: 120,
  bonusPages: 85,
  heroImage: 'https://cdn.magicpatterns.com/uploads/dz9wtp6o2hVD4hb2LgveN1/imagen_principal.png',
  checkoutUrl: 'https://checkout.aula-mater.online/cart/67498055073837:1',
  whatsappUrl: 'https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20Megapack%20Catequesis%20Listas%2C%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion.'
};
export const heroBenefits = ['Actividades prácticas y listas para usar', 'Preparación para Primera Comunión y Confirmación', 'Recursos visuales pensados para niños y adolescentes', '2 BONUS PREMIUM incluidos de regalo'];